module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', [_c('div', {
    staticClass: "tr"
  }, [_c('default-button', {
    nativeOn: {
      "click": function($event) {
        _vm.goToNewProduct($event)
      }
    }
  }, [_vm._v("+ New product")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tl"
  }, [_c('content-card', [_c('h1', [_vm._v("\n        Product list\n      ")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.products && _vm.products.length > 0) ? _c('div', {
    staticClass: "product-list"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product._id,
      staticClass: "product pa2 bg-black-10"
    }, [_c('router-link', {
      staticClass: "no-underline db",
      attrs: {
        "to": {
          name: 'ProductDetails',
          params: {
            productId: product._id
          }
        }
      }
    }, [_vm._v("\n              " + _vm._s(product.name) + "\n            ")])], 1)
  })) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4eb3f08","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./admin/src/components/ProductList.vue
// module id = 258
// module chunks = 0